import useLoggedInRedirect from '@hook/user/useLoggedInRedirect'
import RegisterForm from '@module/RegisterForm/RegisterForm'
import MarketingPageHeader from '@template/GameDashboard/Home/Header'
import {
  BoxRegistrationPageMainFormWrapper,
  BoxRegistrationPageMainWrapper,
  BoxRegistrationPageSubWrapper,
} from './Register.Styled'
// eslint-disable-next-line arrow-body-style
const RegisterPage = () => {
  useLoggedInRedirect()
  return (
    <BoxRegistrationPageMainWrapper sx={{ backgroundColor: 'blue14' }}>
      <MarketingPageHeader />
      <BoxRegistrationPageSubWrapper>
        <BoxRegistrationPageMainFormWrapper>
          <RegisterForm />
        </BoxRegistrationPageMainFormWrapper>
      </BoxRegistrationPageSubWrapper>
    </BoxRegistrationPageMainWrapper>
  )
}
export default RegisterPage
